import * as React from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import { Button } from '@mui/material';

import dayjs from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';

export default function OtherEventForm() {
  const [formData, setFormData] = React.useState({});
  console.log(formData);
  return (
    <React.Fragment>
      <Typography variant="h6" gutterBottom>
        Manual (non-raceHero) Session Details
      </Typography>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <TextField
            required
            id="eventName"
            name="eventName"
            label="Event Name"
            fullWidth
            // autoComplete="shipping address-line2"
            variant="standard"
            onChange={(e) =>
              setFormData({ ...formData, [e.target.name]: e.target.value })
            }
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            required
            id="trackName"
            name="trackName"
            label="Track Name"
            fullWidth
            // autoComplete="given-name"
            variant="standard"
            onChange={(e) =>
              setFormData({ ...formData, [e.target.name]: e.target.value })
            }
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            required
            id="trackConfiguration"
            name="trackConfiguration"
            label="Track Configuration"
            fullWidth
            // autoComplete="family-name"
            variant="standard"
            onChange={(e) =>
              setFormData({ ...formData, [e.target.name]: e.target.value })
            }
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            required
            id="carName"
            name="carName"
            label="Car Name or Description"
            fullWidth
            // autoComplete="shipping address-line1"
            variant="standard"
            onChange={(e) =>
              setFormData({ ...formData, [e.target.name]: e.target.value })
            }
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            required
            id="carNumber"
            name="carNumber"
            label="Car Number"
            fullWidth
            // autoComplete="shipping address-line2"
            variant="standard"
            onChange={(e) =>
              setFormData({ ...formData, [e.target.name]: e.target.value })
            }
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            id="runGroup"
            name="runGroup"
            label="Run Group"
            fullWidth
            // autoComplete="shipping address-level2"
            variant="standard"
            onChange={(e) =>
              setFormData({ ...formData, [e.target.name]: e.target.value })
            }
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            id="sessionNumber"
            name="sessionNumber"
            label="Session Number"
            fullWidth
            variant="standard"
            onChange={(e) =>
              setFormData({ ...formData, [e.target.name]: e.target.value })
            }
          />
        </Grid>

        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <Grid item xs={12} sm={6}>
            <DatePicker
              label="Session Date"
              name="sessionDate"
              // value={value}
              // onChange={(newValue) => setValue(newValue)}
              // onChange={(e) => setFormData({ ...formData, sessionDate: e })}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TimePicker label="Session Time" name="sessionTime" />
          </Grid>
        </LocalizationProvider>
      </Grid>
    </React.Fragment>
  );
}
